import { useMemo } from "react";
import ServiceLocator from "../../../../domain/service-locator";

/**
 * 現在のガイドのArea内インデックス（0始まり）を返すフック
 */
export const useGuideDisplayNumber = (
  guideId: string | undefined
): number | undefined => {
  const entities = ServiceLocator.LocalizedEntityRepository.entities.watch();

  return useMemo(() => {
    if (!guideId) return undefined;

    const guide = entities.guides.find((g) => g.id === guideId);
    if (!guide) return undefined;

    const tour = entities.tours.find((t) => t.id === guide.tourId);
    if (!tour) return undefined;

    const areaTours = entities.tours.filter((t) => t.areaId === tour.areaId);
    const areaGuides = areaTours.flatMap((t) =>
      entities.guides.filter((g) => g.tourId === t.id)
    );

    const index = areaGuides.findIndex((g) => g.id === guideId);
    return index >= 0 ? index : undefined;
  }, [guideId, entities]);
};
